// @mui
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// ----------------------------------------------------------------------

export default function useResponsive(query, key, start, end) {
  const theme = useTheme();

  const mediaUp = useMediaQuery(theme.breakpoints.up(key));
  //console.log('mediaUp ', mediaUp);

  const mediaDown = useMediaQuery(theme.breakpoints.down(key));
  //console.log('mediaDown ', mediaDown);

  const mediaBetween = useMediaQuery(theme.breakpoints.between(start, end));
  //console.log('mediaBetween ', mediaBetween);

  const mediaOnly = useMediaQuery(theme.breakpoints.only(key));
  //console.log('mediaOnly ', mediaOnly);
  //console.log('--------------------------------');

  if (query === 'up') {
    return mediaUp;
  }

  if (query === 'down') {
    return mediaDown;
  }

  if (query === 'between') {
    return mediaBetween;
  }

  if (query === 'only') {
    return mediaOnly;
  }
  return null;
}
